import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchCampaigns, clearCampaignsErrors, deleteCampaign } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  campaigns: PropTypes.object,
  onCampaignDisable: PropTypes.func,
  campaignDisabled: PropTypes.bool,
};

class ShowCampaigns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.campaignDelete && (this.state.delete || nextProps.campaigns.delete)) {
      const campaigns = nextProps.campaigns;
      campaigns.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Campaign deleted!',
        campaigns,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleDisable(p) {
    const data = _.omit(p, ['s3Bucket', 'emailBucket']);
    data.disabled = !p.disabled;
    this.props.onCampaignDisable(data);
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteCampaign(this.state.deleteId));
    this.props.dispatch(fetchCampaigns({ page: 1 }));
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearCampaignsErrors());
    this.props.dispatch(fetchCampaigns({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.campaigns.results.map((campaign, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{campaign.name}</TableRowColumn>
        <TableRowColumn key={i}>{campaign.sentTo}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDisable={() => this.handleDisable(campaign)}
            onEdit={`/campaigns/${campaign.id}`}
            onView={`/campaigns/view/${campaign.id}`}
            disabled={campaign.disabled}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Campaign"
          dialogMessage="Do you really want to delete this campaign?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Campaign Email</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowCampaigns.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowCampaigns.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.campaigns.error,
    campaignDelete: state.campaigns.campaignDelete,
    campaignDisabled: state.campaigns.campaignDisabled,
    campaigns: state.campaigns,
  };
}

export default connect(mapStateToProps)(ShowCampaigns);



// WEBPACK FOOTER //
// ./src/components/campaigns/ShowCampaigns.js